"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrdinal = void 0;

var getOrdinal = function getOrdinal(n) {
  return "".concat(n).concat(['st', 'nd', 'rd'][(((n < 0 ? -n : n) + 90) % 100 - 10) % 10 - 1] || 'th');
};

exports.getOrdinal = getOrdinal;